export default function FilterIcon({ width = 16, height = 15 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.95898 1.375H14.0409C14.1498 1.375 14.2565 1.40665 14.3478 1.46611C14.4391 1.52557 14.5112 1.61028 14.5553 1.70994C14.5994 1.8096 14.6136 1.91991 14.5961 2.02748C14.5787 2.13505 14.5304 2.23524 14.4571 2.31588L9.83371 7.40159C9.73958 7.50513 9.68742 7.64004 9.68742 7.77997V11.7615C9.68742 11.8541 9.66456 11.9452 9.62087 12.0269C9.57717 12.1085 9.51399 12.1781 9.43694 12.2295L7.18694 13.7295C7.10223 13.786 7.00378 13.8184 6.90208 13.8233C6.80039 13.8282 6.69927 13.8054 6.6095 13.7574C6.51974 13.7094 6.4447 13.6379 6.39238 13.5505C6.34006 13.4632 6.31242 13.3633 6.31242 13.2615V7.77997C6.31242 7.64004 6.26027 7.50513 6.16614 7.40159L1.54277 2.31588C1.46946 2.23524 1.42116 2.13505 1.40373 2.02748C1.3863 1.91991 1.40048 1.8096 1.44457 1.70994C1.48866 1.61028 1.56074 1.52557 1.65206 1.46611C1.74338 1.40665 1.85001 1.375 1.95898 1.375Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
